module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/23/assets/images/b6a5084f3460983df835e8acbafd1467.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_star.svg
// module id = IJC2
// module chunks = 0